// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import router from "./router";
import Vuex from 'vuex';
import 'es6-promise/auto';
import i18n from './i18n';

const firebase = require('firebase/app');
require('firebase/database');
require('firebase/auth');

var config = {
    apiKey: "AIzaSyAGwUr0sTC2yZzFTaseJlyGQnIlJ4HvXWA",
    authDomain: "bom-profile.firebaseapp.com",
    databaseURL: "https://bom-profile.firebaseio.com/"
};
firebase.initializeApp(config);

var database = firebase.database();
var profile = database.ref('profile')

Vue.use(BootstrapVue);
Vue.use(Vuex);
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    next()
    var body = document.body;
    body.classList.add("is-preload");
})

router.afterEach(() => {
    setTimeout(function() {
        document.body.className = document.body.className.replace(/\bis-preload\b/, '')
        document.body.className += (navigator.userAgent.match(/(MSIE|rv:11\.0)/) ? ' is-ie' : '');
    }, 50)
})

const getters = {
    lang() {
        return state.lang
    },
    name: () => {
        var lang = state.lang
        return state.name[lang]
    },
    position: () => {
        return state.position
    },
    nickname: () => {
        var lang = state.lang
        return state.nickname[lang]
    },
    birthdate: () => {
        var lang = state.lang
        return state.birthdate[lang]
    },
    skills: () => {
        return state.skills
    },
    facebook: () => {
        return state.facebook
    },
    line: () => {
        return state.line
    },
    ig: () => {
        return state.ig
    },
    email: () => {
        return state.email
    },
    tel: () => {
        return state.tel
    },
    exp: () => {
       return state.exp
    }
}

var mutations = {
    setLang(state, payload) {
        state.lang = payload
    }
}

var actions = {
    setLang(context, value) {
        context.commit('setLang', value)
    }
}

var state = [];

profile.on('value', function(data) {
    state = data.val();
    const store = new Vuex.Store({
        state,
        getters,
        mutations,
        actions
    })

    new Vue({
        el: '#app',
        store,
        components: { App },
        template: '<App/>',
        router,
        i18n
    })
});


// WEBPACK FOOTER //
// ./src/main.js